import Vue from 'vue';
import dateUtility from '../services/dateUtility'

export default Vue.mixin({
    methods: {
        formatTime(value) {
            return dateUtility.formatTimeWithOffset(value);
        },

        formatTimespan(value) {
            return dateUtility.formatTimespan(value);
        },

        formatDateTime(value) {
            return dateUtility.formatDateTime(value);
        },

        formatDate(value) {
            return dateUtility.getDate(value);
        },

        formatCoordinates(coordinates) {
            return coordinates != null ? "(" + coordinates.latitude.toString().substring(0, 10) + ", " + coordinates.longitude.toString().substring(0, 10) + ")" : "";
        },

        formatEnum(value) {
            if (value === null || typeof value === "undefined") {
                return null;
            }
            return value.replace(/([A-Z])/g, ' $1').trim()
        },

        formatLongString(value, length) {
            return (value !== null && typeof value !== "undefined") ? value.substring(0, length) + (value.length > length ? "..." : "") : "";
        }
    }
})
